import SidebarLink from './SidebarLink';
import { isActiveLink } from './hooks';

export default function SidebarNav({ links, activeLink, onLinkClick, isCompact = false }) {
  return (
    <nav className={`flex flex-1 flex-col gap-2 ${isCompact ? 'px-1.5' : 'px-2'}`}>
      {links.map(({ id, label, icon, link }) => (
        <SidebarLink
          key={id}
          icon={icon}
          label={label}
          link={link}
          isActive={isActiveLink(link, activeLink)}
          onClick={onLinkClick}
          isCompact={isCompact}
        />
      ))}
    </nav>
  );
}
